import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import Play from '../../assets/play.svg';

const Controls = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 3;
  padding: 37px 40px 37px;
  opacity: ${({ controlsVisible }) => (controlsVisible ? '1' : '0')};
  transition: opacity 0.2s ease-in-out;
  background: linear-gradient(0deg, ${({ theme }) => theme.colorMain} 25%, rgba(255,255,255,0) 100%);
`

const ControlsTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const TimePlayed = styled.div`
  font-family: ${({ theme }) => theme.fontSans};
  font-size: 12px;
  text-transform: uppercase;
  text-align: center;
  color: ${({ theme }) => theme.colorBg};
`

const Buttons = styled.div`
  display: flex;
`

const Mute = styled.button`
  display: block;
  margin: 0;
  border: 0;
  padding: 10px;
  font-family: ${({ theme }) => theme.fontSans};
  font-size: 12px;
  color: ${({ theme }) => theme.colorBg};
  text-transform: uppercase;

  &:focus {
    outline: none;
  }
`
const Wrapper = styled.div`
 position: relative;
 width: 100%;
 height: calc(100% - 60px);
`

const PlayerVideo = styled.video`
  width: 100%;
  height: auto;
`
const PlayBtn = styled(Play)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  g { fill: ${({ theme }) => theme.colorBg}}
`

const PlayPause = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  width: 100%;
  overflow: hidden;
  text-indent: -9999px;
  border: 0;
  padding: 0;
  margin: 0;
  transition: opacity 0.2s ease-in-out;
  background-image: url('../../assets/play.svg');
`

const ProgressWrapper = styled.div`
  height: 2px;
  width: 100%;
  background-color: ${({ theme }) => theme.bolorBgLight};
  cursor: pointer;
`

const ProgressBar = styled.div`
  display: block;
  width: 0%;
  height: 100%;
  background-color: ${({ theme }) => theme.colorBg};
`

const Player = ({ video }) => {

  const mainWrapper = useRef(null)
  const vid = useRef(null)
  const progressBar = useRef(null)

  let timerInterval = useRef(null)

  const [timePlayed, setTimePlayed] = useState('00:00')
  const [areControlsVisible, setAreControlsVisible] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [showPlayBtn, setShowPlayBtn] = useState(true)


  const playVideo = () => {
    vid.current.play()
    timerInterval.current = setInterval(timer, 1000)
    setAreControlsVisible(true)
  }

  const pauseVideo = () => {
    vid.current.pause()
    clearInterval(timerInterval.current)
  }

  const formattedTime = time => {
    const minutes = Math.floor(time / 60)

    let seconds = time % 60

    if (seconds < 10) {
      seconds = `0${seconds}`
    }

    // The output in MM:SS format
    return `0${minutes || '0'}:${seconds || '00'}`
  }

  const timer = () => {
    if (vid.current) {
      setTimePlayed(formattedTime(Math.round(vid.current.currentTime)))
    }
  }

  const handleMute = () => {
    vid.current.muted = !vid.current.muted
    setIsMuted(!isMuted)
  }


  const setDurationVal = () => {
    progressBar.current.setAttribute(
      'data-max',
      Math.round(vid.current.duration)
    )
  }

  const handleSkipAhead = event => {
    const pos =
      (event.pageX -
        (progressBar.current.parentElement.offsetLeft +
          vid.current.parentElement.offsetLeft)) /
      progressBar.current.parentElement.offsetWidth
    vid.current.currentTime = pos * vid.current.duration

    timer()
  }

  const handleTime = () => {
    if (!progressBar.current.getAttribute('data-max'))
      progressBar.current.setAttribute('data-max', vid.current.duration)

    progressBar.current.style.width =
      Math.round((vid.current.currentTime / vid.current.duration) * 100) + '%'


    if (vid.current.ended && showPlayBtn === false) {
      setShowPlayBtn(true)
    }

    if (vid.current.ended && areControlsVisible === true) {
      setAreControlsVisible(false)
    }

    if (vid.current.ended) {
      vid.current.currentTime = 0
    }

  }


  const handleWrapperClick = setting => {
    setShowPlayBtn(false)

    if (vid.current.paused || vid.current.ended) {
      playVideo()
    } else {
      pauseVideo()
    }
  }

  return (
    <Wrapper
      ref={mainWrapper}
      onClick={handleWrapperClick}
    >
      <PlayerVideo
        ref={vid}
        preload="auto"
        onTimeUpdate={handleTime}
        onLoadedMetadata={setDurationVal}
      >
        <source src={video} type={'video/mp4'} />
      </PlayerVideo>
      <PlayPause visible={showPlayBtn} />
      <PlayBtn visible={showPlayBtn} />
      <Controls
        controlsVisible={areControlsVisible}>
        <ControlsTop>
          <TimePlayed>{timePlayed}</TimePlayed>
          <Buttons>
            <Mute onClick={handleMute} isMuted={isMuted} type="button">
              Sound {isMuted ? 'off' : 'on'}
            </Mute>
          </Buttons>
        </ControlsTop>
        <ProgressWrapper onClick={handleSkipAhead}>
          <ProgressBar ref={progressBar} data-max="0"></ProgressBar>
        </ProgressWrapper>
      </Controls>
    </Wrapper>
  )
}

export default Player;